/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { updateStrategy, getFullListStrategiesAdministration } from '../api';
import { AggregateStrategy } from '../types/aggregateStrategy';

type TAggregateStrategies$State = {
  strategies: AggregateStrategy[];
};

const initialState: TAggregateStrategies$State = {
  strategies: [],
};

export const AggregateStrategies$ = createStore<TAggregateStrategies$State>(initialState);

const { set } = createApi(AggregateStrategies$, {
  // @ts-ignore
  set: (state, { result }) => {
    const data = {
      // @ts-ignore
      strategies: result.result,
    };

    return data;
  },
});

export const aggregateStrategiesApi = {
  get: createEffect<'', {}, {}>().use(getFullListStrategiesAdministration),
  update: createEffect<Partial<AggregateStrategy>, {}, {}>().use(updateStrategy),
};

sample({
  clock: aggregateStrategiesApi.get.done,
  target: set,
});
